import { render, staticRenderFns } from "./TransferPaymentView.vue?vue&type=template&id=f33ed6b0"
import script from "./TransferPaymentView.vue?vue&type=script&lang=ts"
export * from "./TransferPaymentView.vue?vue&type=script&lang=ts"
import style0 from "./TransferPaymentView.vue?vue&type=style&index=0&id=f33ed6b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports